import { Platform } from 'react-native';
import axios from 'axios';

import { authStore } from '@stores/auth';
import { config } from '@~/config';
import { getData } from '@lib/storage';
import { i18n } from '@providers/I18n/i18n';

import { refreshAccessToken } from './refreshAccessToken';

const client = axios.create({
  // use proxy on web, and full url on native
  baseURL: Platform.OS === 'web' ? '/api' : `${config.appUrl}/api`,
  headers: {
    'X-Client-Id': '0417b144-0f3f-11e8-87cc-0242ac110002',
    'Client-Model': Platform.OS,
  },
});

client.interceptors.request.use(async (requestConfig) => {
  const accessToken = (await getData('accessToken')) || '';
  const deviceId = (await getData('deviceId')) || '';

  requestConfig.headers = requestConfig.headers || {};

  requestConfig.headers.Authorization = `Bearer ${accessToken}`;
  requestConfig.headers.lang = i18n.language;
  requestConfig.headers['X-Device-Id'] = deviceId;
  requestConfig.headers['Device-Id'] = deviceId;

  return requestConfig;
});

let isRefreshingToken = false;

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const status = error.response?.status;

    if (!error.response) {
      return Promise.reject(error);
    }

    if (
      (status === 401 || status === 403) && !isRefreshingToken) {
      try {
        isRefreshingToken = true;
        const accessToken = await refreshAccessToken();
        
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;

        return client.request(originalRequest);
      } catch (err) {
        authStore.getState().logout();
      } finally {
        isRefreshingToken = false;
      }
    }

    if (status === 401 || status === 403) {
      authStore.getState().logout();
    }

    return Promise.reject(error);
  },
);

export { client };
